import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Button, ErrorPopup } from '@lt/components';
import { Sizes } from '@lt/components/components/Button/Button';
import withMobile from '../hocs/withMobile';
import { NBSP } from '../../../constants/common';

const CertificateErrorPopup = ({
  isOpen,
  errorMessage,
  orderId,
  onClose,
  goToOrder,
  isMobile,
  ...rest
}) => {
  const isOrderCreated = Boolean(orderId);
  return (
    <ErrorPopup {...rest} isOpen={isOpen} isMobile={isMobile} onClose={onClose}>
      <StyledErrorContent isMobile={isMobile}>
        <StyledErrorHeader>
          {isOrderCreated ? 'Списание не удалось' : 'Не удалось создать заказ'}
        </StyledErrorHeader>
        <StyledErrorMessage>{errorMessage}</StyledErrorMessage>
        <StyledRetryButton onClick={onClose}>
          Попробовать еще раз
        </StyledRetryButton>
        {isOrderCreated && (
          <Button functional onClick={goToOrder} className="lt-link">
            Перейти к заказу
          </Button>
        )}
        <StyledErrorMessage>
          {`Если ошибка повторится, свяжитесь с${NBSP}нашим клиентским сервисом${NBSP}`}
          <span className="nowrap">по телефону +7 495 134-44-11</span>
          <br />
          {isOrderCreated && `Ваш номер заказа: ${orderId}`}
        </StyledErrorMessage>
      </StyledErrorContent>
    </ErrorPopup>
  );
};

const StyledErrorMessage = styled.div`
  margin: 20px 0;
  font-size: 14px;
  text-align: center;
  white-space: pre-wrap;
  color: ${(props) => props.theme.colors.blackLight};
`;

const StyledErrorHeader = styled.div`
  margin-top: 20px;
  font-size: 28px;
  font-weight: bold;
  color: ${(props) => props.theme.colors.blackBase};
`;

const StyledRetryButton = styled(Button).attrs({
  primary: true,
  size: Sizes.FLEX,
})`
  margin-bottom: 15px;
  font-size: 14px;
`;

const StyledErrorContent = styled.div`
  padding: 0 80px;
  display: flex;
  box-sizing: border-box;
  max-width: 600px;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${({ isMobile }) =>
    isMobile &&
    css`
      padding: 0;

      ${StyledErrorHeader} {
        font-size: 22px;
      }
    `}
`;

CertificateErrorPopup.propTypes = {
  isMobile: PropTypes.bool,
  isOpen: PropTypes.bool,
  orderId: PropTypes.number,
  errorMessage: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  goToOrder: PropTypes.func.isRequired,
};
CertificateErrorPopup.defaultProps = {
  isMobile: false,
  isOpen: false,
  orderId: null,
};

export default withMobile(CertificateErrorPopup);
